import { DataLayer } from "@grandvisionhq/analytics";
import { PaymentMethod } from "@grandvisionhq/payments";
const getInteractionType = (paymentMethod) => {
  switch (paymentMethod) {
    case PaymentMethod.APPLE_PAY:
      return "express_applepay_init";
    case PaymentMethod.PAYPAL:
      return "express_paypal_init";
    case PaymentMethod.GOOGLE_PAY:
      return "express_googlepay_init";
    default:
      return "";
  }
};
const mapCartDataToExpressInit = (cart, paymentMethod, isLoggedIn) => {
  const getBrand = (lineItem) => {
    const brand = lineItem.type == "prescription-glasses" ? lineItem.frame.brand.name : lineItem.brand.name;
    return brand || "";
  };
  const getSku = (lineItem) => {
    const sku = lineItem.type == "prescription-glasses" ? lineItem.frame.sku : lineItem.sku;
    return sku || "";
  };
  const getCategory = (productType, lineItemType) => {
    switch (lineItemType) {
      case "sunglasses":
        return DataLayer.DataLayerTypes.Category.Sunglasses;
      case "contact-lenses":
        return DataLayer.DataLayerTypes.Category.ContactLenses;
      case "solutions":
        return DataLayer.DataLayerTypes.Category.Solutions;
      case "frames":
      case "non-prescription-bundle":
      case "prescription-glasses":
        return productType === "sunglasses" ? DataLayer.DataLayerTypes.Category.Sunglasses : DataLayer.DataLayerTypes.Category.Optical;
      case "ready-readers":
        return DataLayer.DataLayerTypes.Category.ReadyReaders;
      case "accessories":
        return DataLayer.DataLayerTypes.Category.Accessories;
      default:
        return "";
    }
  };
  return {
    event: "express_checkout_init_click",
    site_feature: "express_checkout",
    interaction_type: getInteractionType(paymentMethod),
    session_status: isLoggedIn ? "logged_in" : "guest",
    items: cart.lineItems.map((item) => ({
      sku: getSku(item),
      quantity: `${item.quantity}`,
      brand: getBrand(item),
      category: getCategory(item.productType, item.type)
    })) || []
  };
};
export {
  mapCartDataToExpressInit
};
//# sourceMappingURL=express-init-mapper.js.map
